import { HtmlTextParser } from '../helpers/html-text-parser.helper';
import { ConfigurationService } from './configuration.service';

interface ITranslation {
  key: string;
  value: string;
}

declare const window: {
  vt: {
    translations: ITranslation[];
  };
};

export class TranslationService {
  private static analyzeEnabled = false;

  public static init(): void {
    this.analyzeEnabled = ConfigurationService.get('analyze') === 'True';
    if (this.analyzeEnabled) {
      this.analyzeDuplicates();
    }
  }

  private static analyzeDuplicates(): void {
    if (!window.vt.translations) {
      return;
    }

    const parameters = window.vt.translations as ITranslation[];

    const duplicateKeys = [];

    const allKeys = parameters.map((x) => x.key).sort();

    for (let i = 0; i < allKeys.length; i += 1) {
      if (allKeys[i + 1] === allKeys[i]) {
        duplicateKeys.push(allKeys[i]);
      }
    }

    if (duplicateKeys.length > 0) {
      console.log(`Följande klientöversättningar förekommer flera ggr: ${duplicateKeys.toString()}`);
    }
  }

  public static get(key: string): string {
    try {
      if (!window.vt.translations) {
        return '';
      }

      const parameters = window.vt.translations as ITranslation[];

      const translationEntry = parameters.find((p) => p.key === key);

      if (this.analyzeEnabled && !translationEntry) {
        console.log(`TranslationService: ${key} not found`);
      }

      return translationEntry !== undefined ? HtmlTextParser.decodeHtmlEntity(translationEntry.value) : '';
    } catch {
      if (this.analyzeEnabled) {
        console.log(`TranslationService (catch): ${key} not found`);
      }
      return '';
    }
  }
}
